import api from '@/utils/axios';

/**
 * 수급 관련 API 서비스
 */
const marketFlowService = {
  // ================================
  // 유통시장 API
  // ================================
  
  /**
   * 유통시장 매수 파일 업로드
   */
  async uploadSecondaryBuyFile(date, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.postFormData(
        `/api/v1/market-flow/secondary/buy/upload?date=${date}`,
        formData
      );
      return response;
    } catch (error) {
      console.error('유통시장 매수 파일 업로드 실패:', error);
      throw error;
    }
  },

  /**
   * 유통시장 매도 파일 업로드
   */
  async uploadSecondarySellFile(date, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.postFormData(
        `/api/v1/market-flow/secondary/sell/upload?date=${date}`,
        formData
      );
      return response;
    } catch (error) {
      console.error('유통시장 매도 파일 업로드 실패:', error);
      throw error;
    }
  },

  /**
   * 유통시장 수급 분석
   */
  async analyzeSecondaryMarket(date) {
    try {
      const response = await api.post('/api/v1/market-flow/secondary/analyze', {
        date,
      });
      return response;
    } catch (error) {
      console.error('유통시장 수급 분석 실패:', error);
      throw error;
    }
  },

  // ================================
  // 발행시장 API
  // ================================
  
  /**
   * 발행시장 인수 파일 업로드
   */
  async uploadPrimaryIssuanceFile(date, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.postFormData(
        `/api/v1/market-flow/primary/issuance/upload?date=${date}`,
        formData
      );
      return response;
    } catch (error) {
      console.error('발행시장 인수 파일 업로드 실패:', error);
      throw error;
    }
  },

  /**
   * 발행시장 수급 분석
   */
  async analyzePrimaryMarket(date) {
    try {
      const response = await api.post('/api/v1/market-flow/primary/analyze', {
        date,
      });
      return response;
    } catch (error) {
      console.error('발행시장 수급 분석 실패:', error);
      throw error;
    }
  },

  // ================================
  // 수급 레코드 조회 API
  // ================================

  /**
   * 채권 수급 레코드 조회
   */
  async getRecords(date) {
    try {
      const response = await api.get('/api/v1/market-flow/records', {
        params: { date },
      });
      return response;
    } catch (error) {
      console.error('수급 레코드 조회 실패:', error);
      throw error;
    }
  },
};

export default marketFlowService;

